import {handleOpenSlabModeConflict} from "../bvcomponents/sqft/components/popup/modalFix/slabFix/slabModeConflictHelper";
import store from "../store";
import {setWizardConflictPopupOpened} from "../actions/wizardFunctions";

export const handleOpenConflictPopups = () => {
  const state = store.getState();
  const {wizardConflictingSteps} = state.wizardState;
  if (wizardConflictingSteps.length) {
    store.dispatch(setWizardConflictPopupOpened(true));
  } else  {
    handleOpenSlabModeConflict().then(() => undefined);
  }
}
